import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';
import type {
    GetAiHomepage as GetAiHomepageQuery,
    GetAiHomepage_aiHomepage as AiHomepage,
    GetAiHomepageVariables,
} from 'nutshell-graphql-types';

import GET_AI_HOMEPAGE from '../queries/get-ai-homepage.graphql';

export const useGetAiHomepage = (
    period: AiFeaturePeriod
): {
    aiHomepage: AiHomepage | null | undefined;
    hasAiUsage: boolean;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetAiHomepageQuery, GetAiHomepageVariables>(
        GET_AI_HOMEPAGE,
        {
            variables: {period},
            fetchPolicy: 'cache-and-network',
        }
    );

    const aiHomepage = data ? data.aiHomepage : null;

    return {
        aiHomepage,
        hasAiUsage: aiHomepage ? aiHomepage.hasAiUsage : false,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
